export default function Manifesto() {
  return (
    <section className="relative overflow-hidden bg-accent-100/40">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-7">
            <span className="text-xs font-semibold tracking-[0.3em] text-accent-700">
              WHY CHIGUA
            </span>
            <h2 className="mt-3 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
              不是追着瓜跑，
              <br />
              而是把故事讲清楚
            </h2>
            <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-foreground-700">
              我们相信，热度会过去，而扎实的整理与独立的判断能留下来。吃瓜官网坚持核实信息、
              标注来源、给出脉络，让每一次「吃瓜」都变成一次有价值的信息抵达。无论你是读者、
              创作者还是合作伙伴，欢迎和我们一起，把「看热闹」升级成「看得懂」。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#business"
                className="whitespace-nowrap rounded-md bg-accent-600 px-6 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-accent-500"
              >
                了解合作机会
              </a>
              <a
                href="#collection"
                className="whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-6 py-3 text-center text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-700"
              >
                逛逛内容看板
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <figure className="relative">
              <div className="overflow-hidden rounded-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20vertical%20editorial%20composition%20of%20warm%20cream%20magazine%20pages%20with%20dried%20botanical%20leaves%20and%20a%20small%20ripe%20watermelon%20slice%20on%20a%20linen%20surface%2C%20soft%20olive%20and%20cream%20palette%2C%20calm%20editorial%20brand%20storytelling%20photography%2C%20gentle%20natural%20lighting&width=1000&height=1200&seq=chigua-manifesto-x1&orientation=portrait"
                  alt="吃瓜官网品牌故事 内容理念杂志视觉"
                  title="吃瓜官网品牌故事"
                  className="h-[380px] w-full object-cover md:h-[460px]"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 hidden rounded-md bg-primary-500 px-4 py-3 text-background-50 md:block">
                <p className="font-heading text-2xl font-bold leading-none">6 年</p>
                <p className="mt-1 text-xs">坚持核实内容</p>
              </div>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}